/* eslint-disable no-useless-catch */
import { PREFIX_ADMIN_API } from 'utils/constants';

import { serialize } from '../utils';
import { AddressData } from './address';
import {
  FindChildOrderByCustomerOptions,
  FindOneOptions,
  FindOptions,
  FindOrderDeliveryInfoOptions,
  FindOrderTaskInfoOptions,
} from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/orders';

export const OrderApi = {
  // TODO: check

  findByAdminAsSupplier: async (option: FindOptions) => {
    let url = `${PREFIX_ADMIN_API}${pathname}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneByOrderCode: async (orderCode: string) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/${orderCode}/entity`;
    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  findByAdminAsCustomer: async (option: FindOptions) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/as-customer`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findChildOrdersByCustomer: async (
    options: FindChildOrderByCustomerOptions
  ) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/group-by-product-of-customer`;
    const query = serialize(options);
    url += query;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  findOrderDeliveryInfo: async (options: FindOrderDeliveryInfoOptions) => {
    const url = `${pathname}/find-order-delivery-info`;

    try {
      return await entityService.post(url, options);
    } catch (error) {
      throw error;
    }
  },

  findPurchaseOrderTaskInfo: async (options: FindOrderTaskInfoOptions) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/find-purchase-order-task-info`;

    try {
      return await entityService.post(url, options);
    } catch (error) {
      throw error;
    }
  },

  findOrderTaskInfo: async (options: FindOrderTaskInfoOptions) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/find-order-task-info`;

    try {
      return await entityService.post(url, options);
    } catch (error) {
      throw error;
    }
  },

  findByCollaborator: async (option: FindOptions) => {
    let url = `${pathname}/by-collaborator`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findBuyListByAdmin: async (option: FindBuyOrderListQuery) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/buy-list`;
    const { startedAt, finishedAt, notInOrderIDs, customerIDs, ...newOption } =
      option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        startedAt,
        finishedAt,
        notInOrderIDs,
        customerIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  findSaleListByAdmin: async (option: FindSaleOrderListQuery) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/sale-list`;
    // let url = `${pathname}/sale-list`;
    const {
      startedAt,
      finishedAt,
      notInOrderIDs,
      supplierIDs,
      customerGroupOrderIDs,
      customerGroupIDs,
      ...newOption
    } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        startedAt,
        finishedAt,
        notInOrderIDs,
        supplierIDs,
        customerGroupOrderIDs,
        customerGroupIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOrdersToMultiUpdateStatus: async (option: FindOrdersUpdateMultiQuery) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/find-orders-to-multi-update-status`;
    // let url = `${pathname}/sale-list`;
    const { customerGroupOrderIDs, supplierIDs, ...newOption } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        customerGroupOrderIDs,
        supplierIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  findSaleListStatistics: async (option: FindSaleOrderListQuery) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/sale-list/statistics`;
    // let url = `${pathname}/sale-list`;
    const { startedAt, finishedAt, notInOrderIDs, supplierIDs, ...newOption } =
      option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        startedAt,
        finishedAt,
        notInOrderIDs,
        supplierIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  findSaleListByCollaborator: async (option: FindSaleOrderListQuery) => {
    let url = `${pathname}/sale-list-by-collaborator`;
    const { startedAt, finishedAt, ...newOption } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        startedAt,
        finishedAt,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneOrderBill: async (id: string, body: any) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/${id}/bill`;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOrderBills: async (body: any) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/bills`;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneBySupplier: async (id: string, option: FindOneOptions) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneAsCustomerByAdmin: async (id: string, option: FindOneOptions) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/${id}/as-customer`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findDraftOrderItems: async (id: string, body: any) => {
    const url = `${pathname}/wholesale-for-partner/draft-order-items`;
    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneByCollaborator: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}/by-collaborator`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneAdditionalOrder: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}/additional-order`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOrderToExportWithQuantityInfo: async (body: any) => {
    const { order, ...newBody } = body;

    let url = `${PREFIX_ADMIN_API}${pathname}/find-order-to-export-with-quantity-info`;
    const query = serialize({ order });
    url += query;

    try {
      const response = await entityService.post(url, newBody);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOrderToExportWithProductInfo: async (option, body) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/find-order-to-export-with-product-info`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  createMultiOrdersWithPaths: async (body: any) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/wholesale/with-paths`;
    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  confirmMultiOrdersWithPaths: async (body: any) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/wholesale/confirm-info/with-paths`;
    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  confirmMultiOrdersWithPath: async (body: any) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/wholesale/confirm-info/with-path`;
    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // deprecated
  create: async (body: any) => {
    const url = `${pathname}`;
    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  confirmOrderDelivered: async (params: any) => {
    const { id, body } = params;
    // const url = `${PREFIX_ADMIN_API}${pathname}/${id}/confirm-amount-delivered`;
    const url = `${PREFIX_ADMIN_API}${pathname}/${id}/confirm-amount-delivered-optimize`;
    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  confirmOrderReceived: async (params: any) => {
    const { id, body } = params;
    const url = `${PREFIX_ADMIN_API}${pathname}/${id}/confirm-amount-received-optimize`;
    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  /**
   * @deprecated
   */
  createForward: async (param: any) => {
    const { option, body } = param;
    let url = `${pathname}/forward`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // TODO: check
  update: async (id: string, body: any = {}) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateOrderAddress: async (id: string, body: any = {}) => {
    const url = `${pathname}/update-address/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  quickUpdateOrderV2: async (
    id: string,
    options: any,
    body: QuickUpdateOrderBody
  ) => {
    let url = `${pathname}/quick-update-for-customer-v2/${id}`;

    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // TODO: check
  updateOrder: async (id: string, body: UpdateOrderBody) => {
    const url = `${pathname}/update-for-customer/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id: string, body: any = {}) => {
    // const url = `${PREFIX_ADMIN_API}${pathname}/${id}/status-optimize`;
    const url = `${PREFIX_ADMIN_API}${pathname}/${id}/status`;

    // if (isOptimize) {
    //   url = `${PREFIX_ADMIN_API}${pathname}/${id}/status-optimize`;
    // }

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updatePaymentStatus: async (id: string, body: any = {}) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/${id}/payment-status`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  manualUpdatePendingExecuteOrderStatus: async (id: string) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/${id}/manual-update-pending-execute-order`;

    try {
      const response = await entityService.patch(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  manualConfirmPendingExecuteOrderStatus: async (id: string) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/${id}/manual-confirm-pending-execute-order`;

    try {
      const response = await entityService.patch(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  mergeAdditionalOrder: async (id: string) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/${id}/merge-additional-order`;

    try {
      const response = await entityService.patch(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  quickMergeWholesaleOrdersV2: async (body: any) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/quick-merge-wholesale-orders-v2`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  quickMergeWholesaleOrders: async (body: any) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/quick-merge-wholesale-orders-v2`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateMultiStatus: async (body: {
    orders: any[];
    shouldCheckAllItemSupplierQuantityZero: boolean;
  }) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/multi/status`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  mergeOrder: async (body: any = {}) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/merge`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkOrderItemQuantityToCreateOrUpdateOrder: async (
    body: UpdateOrderBody
  ) => {
    const url = `${pathname}/wholesale-for-partner/check-proposal-item-customer-quantity`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOrderToUpdateForCustomerBySupplier: async (id: string) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/update-for-customer/${id}`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createWholesaleDraftOrderForPartner: async (body: any = {}) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/wholesale-for-partner/draft`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createWholesaleOrderForPartner: async (body: any = {}) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/wholesale-for-partner`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkCanUpdateOrderNote: async (
    id: string,
    body: CheckUpdateOrderNoteBody
  ) => {
    const url = `${pathname}/can-update-note/${id}`;
    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateOrderNote: async (id: string, body: UpdateOrderNoteBody) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/update-note/${id}`;
    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  resetTotalQuantity: async (body: ResetTotalQuantityBody) => {
    const url = `${PREFIX_ADMIN_API}${pathname}/reset-total-quantity/status`;
    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateIsSplitLock: async (id, body: UpdateIsSplitLockOrder) => {
    const url = `${pathname}/update-is-split-lock/${id}`;
    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findToBalance: async (params: FindOrdersToBalanceOptions) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/find-to-balance`;
    const query = serialize(params.options);
    url += query;

    try {
      const response = await entityService.post(url, params.body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  updateMultiOrderStatusForSplitOrder: async (
    body: UpdateMultiOrderStatusForSplitOrderBody
  ) => {
    const url = `${pathname}/multi/status/split-order`;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findFirstOrderForMultiConfirmUpdateStatus: async (
    options: any,
    body: FindFirstOrderForMultiConfirmUpdateStatusBody
  ) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/find-first-order-for-multi-confirm-update-status`;
    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOrderForConfirmUpdateStatus: async id => {
    const url = `${PREFIX_ADMIN_API}${pathname}/find-order-for-confirm-update-status/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  updateSupplierQuantityEqualCustomerQuantity: async id => {
    const url = `${PREFIX_ADMIN_API}${pathname}/update-supplier-quantity-equal-customer-quantity/${id}`;

    try {
      const response = await entityService.patch(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findStatisticTotalInfoForEntityProduct: async (
    params: FindStatisticTotalInfoForEntityProductQuery
  ) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/find-statistics-total-info-for-entity-product`;
    const query = serialize(params);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findStatisticTotalInfoForChainEntity: async (
    params: FindStatisticTotalInfoForChainEntityQuery
  ) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/find-statistics-total-info-for-chain-entity`;
    const query = serialize(params);
    url += query;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findRevenueForEntityProduct: async (
    params: FindRevenueForEntityProductQuery,
    body: FindRevenueForEntityProductBody
  ) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/find-revenue-for-entity-product`;
    const query = serialize(params);
    url += query;
    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findStatisticTotalInfoForCustomerEntity: async (
    params: FindStatisticTotalInfoForCustomerQuery
  ) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/find-statistics-total-info-for-customer`;
    const query = serialize(params);
    url += query;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findStatisticsTotalInfoForEntityProductWithSupplier: async (
    params: FindStatisticTotalInfoForEntityProductQuery
  ) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/find-statistics-total-info-for-entity-product-with-supplier`;
    const query = serialize(params);
    url += query;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findStatisticsTotalInfoForEntityProductWithCustomer: async (
    params: FindStatisticTotalInfoForEntityProductWithCustomerQuery
  ) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/find-statistics-total-info-for-entity-product-with-customer`;
    const query = serialize(params);
    url += query;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOrderItemQuantityStatistics: async (
    params: FindOrderItemQuantityStatisticsQuery
  ) => {
    let url = `${pathname}/find-order-item-quantity-statistics`;
    const query = serialize(params);
    url += query;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findCustomerForExportOrder: async (
    params: FindCustomerForExportOrderQuery,
    body: FindCustomerForExportOrderBody
  ) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/find-customer-for-export-order`;
    const query = serialize(params);
    url += query;
    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findPaymentTransaction: async (orderID: string) => {
    const url = `${pathname}/find-payment-transaction/${orderID}`;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findPaymentTransactionCustom: async (
    body: FindPaymentTransactionCustomBody
  ) => {
    const url = `${pathname}/find-payment-transaction-custom`;
    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findPaymentBillTransaction: async (billID: string) => {
    const url = `${pathname}/find-bill-payment-transaction/${billID}`;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findDraftOrdersForPartner: async (
    option: FindDraftOrdersForPartnerQuery,
    body: FindDraftOrdersForPartnerBody
  ) => {
    let url = `${PREFIX_ADMIN_API}${pathname}/find-draft-orders-for-partner`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  /**
   * API lấy thông tin các đơn hàng đang xử lý
   * @returns
   */
  findProcessingOrderUpdateStatusForSplitOrder: async (
    option: FindProcessingOrderUpdateStatusQuery
  ) => {
    let url = `${pathname}/find-order-processing-queue`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOrderForSplitOrder: async id => {
    const url = `${PREFIX_ADMIN_API}${pathname}/${id}/find-for-split-order`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FindOrdersToBalanceOptions {
  options: {
    type?: number;
    customerName?: string;
    page: number;
    take: number;
  };
  body: {
    ids?: string[];
    balanceType?: number;
    entityProductIDs?: string[];
    entityProducts: any;
    supplierIDs?: string[];
    startedAt?: string;
    finishedAt?: string;
  };
}

export interface FindBuyOrderListQuery {
  entityID?: string;
  entityType: number;
  supplierID?: string;
  supplierName?: string;
  name?: string;
  balanceType?: number;
  customerIDs?: string[];
  orderType?: number;
  orderTypes?: number[];
  orderStatus?: number;
  ninOrderStatuses?: (number | string)[] | undefined;
  inOrderStatuses?: (number | string)[] | undefined;
  notInOrderIDs?: string[] | undefined;
  orderStatuses?: number[];
  startedAt?: string;
  finishedAt?: string;
  order?: any;
  page?: number;
  take?: number;
  skip?: number;
  reserved?: boolean;
}

export interface FindSaleOrderListQuery {
  entityID?: string;
  entityType: number;
  customerID?: string;
  customerName?: string;
  name?: string;
  balanceType?: number;
  customerGroupOrderIDs?: string[];
  customerGroupIDs?: string[];
  supplierIDs?: string[];
  orderType?: number;
  orderTypes?: number[];
  orderStatus?: number;
  ninOrderStatuses?: (number | string)[] | undefined;
  inOrderStatuses?: (number | string)[] | undefined;
  notInOrderIDs?: string[] | undefined;
  orderStatuses?: number[];
  startedAt?: string;
  finishedAt?: string;
  order?: any;
  page?: number;
  take?: number;
  skip?: number;
  reserved?: boolean;
}

export interface FindOrdersUpdateMultiQuery {
  customerName?: string;
  supplierIDs?: string[];
  customerGroupOrderIDs?: string[];
  orderTypes?: number[];
  inOrderStatuses?: (number | string)[] | undefined;
  balanceType?: number;
  page?: number;
  take?: number;
  skip?: number;
}

interface CheckUpdateOrderNoteBody {
  supplierNote?: string;
  customerNote?: string;
}

interface UpdateOrderNoteBody {
  supplierNote?: string;
  customerNote?: string;
}

export interface ResetTotalQuantityBody {
  resetTotalCustomerOrderQuantity: {
    value: boolean;
    orderStatus: number;
  };
  resetTotalOrderQuantityToSupplier: {
    value: true;
    orderStatus: number;
  };
}

export interface UpdateIsSplitLockOrder {
  isSplitLock: boolean;
  acceptFullOrderCustomerQuantity: boolean;
}

export interface QuickUpdateOrderBody {
  orderItemID?: string;
  productID?: string;
  customerQuantity?: number;
  supplierQuantity?: number;
}

export interface UpdateOrderBody {
  orderID: string;
  addressID: string;
  paymentMethod: number;
  deliveryMethod: number;
  currentPrice?: number;
  customerNote?: string;
  supplierNote?: string;
  selectedProducts: any[];
  currentAddress?: AddressData;
  supplierID?: string;
  customerID?: string;
  deliveryFee?: number;
  deliveryFeeType?: number;
  locationShippingFee?: any;
  transportNote?: any;
  bankAccountID?: string;
  entityShippingPolicyItemID?: string;
  medias?: any[];
  promotions?: any[];
  entityPricePolicyID?: string;
  oldEntityPricePolicyID?: string;
  entityProposalPolicyID?: string;
  oldEntityProposalPolicyID?: string;
  shouldPrint?: boolean;
  orderEntityShippingPolicyItem?: any;
  orderEntityDistanceShippingFee?: any;
  orderEntityCustomShippingFees?: any[];
  selectedOrderSalePromotionCondition?: any;
}

export interface OrderData {
  id: string;
  additionalOrderID?: string;
  acceptFullOrderCustomerQuantity?: boolean;
  isSplitLock?: boolean;
  payUrl?: string;
  orderItems: any[];
  orderOptions: any;
  customer: any;
  supplier: any;
  collaborator: any;
  code: string;
  type?: string;
  status: number;
  createdAt: string;
  totalPrice: number;
  totalOrderItem?: number;
  additionalInfo?: any;
  isLoadingOrderAction?: boolean;
  pageIndex?: number;
  partnerID?: string;
}

export interface BillData {
  id: string;
  additionalOrderID?: string;
  acceptFullOrderCustomerQuantity?: boolean;
  isSplitLock?: boolean;
  payUrl?: string;
  orderItems: any[];
  orderOptions: any;
  customer: any;
  supplier: any;
  collaborator: any;
  code: string;
  type?: string;
  status: number;
  createdAt: string;
  totalPrice: number;
  additionalInfo?: any;
  isLoadingOrderAction?: boolean;
  pageIndex?: number;
  partnerID?: string;
}

export interface UpdateMultiOrderStatusForSplitOrderBody {
  entityProductIDs?: string[];
  orderIDs?: string[];
  page?: number;
  take?: number;
  status?: number;
  shouldCheckAllItemSupplierQuantityZero?: boolean;
  shouldCheckTotalSupplierQuantityZero?: boolean;
  isAutoRejectOrderWhenTotalSupplierQuantityZero?: boolean;
  customerName?: string;
  type?: number;
  supplierID?: string;
  startedAt?: string;
  finishedAt?: string;
  entityProducts?: any;
  balanceType?: number;
}

export interface FindFirstOrderForMultiConfirmUpdateStatusBody {
  customerName?: string;
  type?: number;
  balanceType?: number;
  supplierID?: string;
  startedAt?: string;
  finishedAt?: string;
  entityProducts?: any;
}

export interface FindStatisticTotalInfoForEntityProductQuery {
  startedAt: string;
  finishedAt: string;
  entitySubCategoryID?: string;
  entityCategoryID?: string;
  orderStatus?: number[];
  orderTypes?: number[];
  supplierIDs?: string[];
  hasOrder?: boolean;
  name?: string;
  isGetAll?: boolean;
  shouldReturnCustomerList?: boolean;
}

export interface FindStatisticTotalInfoForEntityProductWithCustomerQuery {
  startedAt: string;
  finishedAt: string;
  entitySubCategoryID?: string;
  entityCategoryID?: string;
  orderStatus?: number[];
  orderTypes?: number[];
  customerIDs?: string[];
  hasOrder?: boolean;
  name?: string;
  isGetAll?: boolean;
  isGroupWithUser?: boolean;
}

export interface FindStatisticTotalInfoForChainEntityQuery {
  startedAt: string;
  finishedAt: string;
  entityProductID: string;
  entitySubCategoryID?: string;
  entityCategoryID?: string;
  orderStatus?: number[];
  orderTypes?: number[];
}

export interface FindStatisticTotalInfoForCustomerQuery {
  startedAt: string;
  finishedAt: string;
  entityProductID: string;
  orderStatus?: number[];
  orderTypes?: number[];
  name?: string;
}

export interface FindOrderItemQuantityStatisticsQuery {
  customerGroupOrderID?: string;
  orderID?: string;
}

export interface FindRevenueForEntityProductQuery {
  startedAt: string;
  finishedAt: string;
  page?: number;
  take?: number;
  orderStatus?: number[];
  orderTypes?: number[];
  name?: string;
  isGetAll?: boolean;
  hasOrder?: boolean;
}

export interface FindRevenueForEntityProductBody {
  entityProductIDs?: string[];
  supplierIDs?: string[];
}

export interface FindCustomerForExportOrderQuery {
  startedAt: string;
  finishedAt: string;
  page?: number;
  take?: number;
  inStatuses?: number[];
  name?: string;
}

export interface FindCustomerForExportOrderBody {
  supplierIDs?: string[];
}

export interface FindDraftOrdersForPartnerQuery {
  page?: number;
  take?: number;
  supplierID?: string;
  supplierIDs?: string[];
}

export interface FindDraftOrdersForPartnerBody {
  supplierIDs: string[];
}

export interface FindProcessingOrderUpdateStatusQuery {
  balanceType: number;
  isAllStatus?: boolean;
}

export interface FindPaymentTransactionCustomBody {
  bankAccountID: string;
  amount: number;
  description: string;
}
